import React from "react";
import { FormattedMessage } from "react-intl";

const StatementExchangeMarketsHeader: React.FC<{}> = () => {
  const headers = [
    <div className="header">
      <FormattedMessage tagName="span" id="reports-date" />
    </div>,
    <div className="header">
      <FormattedMessage tagName="span" id="reports-bet-type" />
    </div>,
    <div className="header">
      <FormattedMessage tagName="span" id="reports-selection" />
    </div>,
    <div className="header header__center">
      <FormattedMessage tagName="span" id="reports-market-subtotal" />
    </div>,
    <div className="header header__center">
      <FormattedMessage tagName="span" id="reports-market-commission" />
    </div>,
    <div className="header header__center">
      <FormattedMessage tagName="span" id="reports-payout" />
    </div>,
  ];

  return (
    <>
      {headers.map((header, index) => (
        <div key={index} className={"statement-exchange-header"}>
          {header}
        </div>
      ))}
    </>
  );
};

export default StatementExchangeMarketsHeader;
